import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AIChatWidget from './AIChatWidget';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading, initialized, token } = useAuth();

  // Show loading only if we have a token but haven't initialized yet
  if (!initialized && token) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="text-center">
          <div className="relative">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-[#F19143] mx-auto"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-2xl">📦</span>
            </div>
          </div>
          <p className="mt-4 text-gray-600 font-medium">Loading your data...</p>
          <p className="text-sm text-gray-400 mt-1">Please wait</p>
        </div>
      </div>
    );
  }

  // If loading is done and no user, redirect to login
  if (!loading && !user) {
    return <Navigate to="/login" replace />;
  }

  // If still loading with no token, redirect to login
  if (!token && !user) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && user?.role !== 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  // If we have a user (either from localStorage or verified), render children
  if (user) {
    return (
      <>
        {children}
        <AIChatWidget />
      </>
    );
  }

  // Fallback loading state
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4A6B8A] mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  );
};

export default ProtectedRoute;
